module.exports = {
  "country": "AM",
  "artist": "Aram MP3",
  "song": "Not Alone",
  "year": "2014",
  "place": "4",
  "spotify": "1LMUArwQoJRXXkppeGV10D"
};